import cronstrue from "cronstrue";
import { format } from "date-fns";

/** Local date + time, always with hh:mm — e.g. "08/25/2026 14:03". */
export function formatLocalDateTime(value?: string | Date | null): string {
	return value ? format(new Date(value), "P HH:mm") : "-";
}

/** The same instant in UTC, for tooltips — e.g. "2026-08-25 12:03 UTC". */
export function formatUtcDateTime(value?: string | Date | null): string {
	return value
		? `${new Date(value).toISOString().slice(0, 16).replace("T", " ")} UTC`
		: "-";
}

/**
 * Converts a cron expression to a human-readable string.
 * Handles both standard 5-field and EventBridge 6-field `cron(...)` wrappers.
 * Returns the original expression unchanged if parsing fails.
 */
export function describeCron(expression: string): string {
	const unwrapped = expression.match(/^cron\((.+)\)$/)?.[1] ?? expression;
	try {
		return cronstrue.toString(unwrapped, { use24HourTimeFormat: false });
	} catch {
		return expression;
	}
}

// simple fast hash for change detection
export function hashString(str: string): number {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = (Math.imul(31, hash) + str.charCodeAt(i)) | 0;
	}
	return hash;
}

export function formatSize(bytes: number): string {
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const ID_PATTERN = /^[a-z]+_[a-z0-9]+$/i;

export function toLabel(segment?: string | null): string {
	return formatNullableString(
		segment
			?.toLocaleLowerCase()
			.replace(/-/g, " ")
			.replace(/^./, (char) => char.toLocaleUpperCase()),
	);
}

/** Renders a string value, or a muted "Not set" placeholder when empty/null. */
export function formatNullableString(value?: string | null): string {
	return value ? value : "-";
}
